<template>
  <main class="main main--terms">
    <component
      :is="content"

      class="group group--first-last typeset typeset--terms links"
    />
    <ui-footer />
  </main>
</template>

<script>
// Models
import meta from 'models/meta';
import terms from 'models/content/terms.md';
import privacy from 'models/content/privacy.md';

// Services
import { createMeta } from 'services/meta';

// Ui
import UiFooter from 'ui/Footer';

// Export
export default {
  name: `view-terms`,

  // Meta data
  metaInfo() {
    return {
      title: meta[this.$route.name].title,
      meta: createMeta(meta[this.$route.name].meta),
    };
  },

  // Components
  components: {
    UiFooter,
  },

  // Data
  data() {
    return {
      map: {
        terms,
        privacy,
      },
    };
  },
  computed: {
    content() {
      return this.map[this.$route.name];
    },
  },
};
</script>



// WEBPACK FOOTER //
// Terms.vue?c23787f8